import React from 'react'
import PropTypes from 'prop-types'
import ChooseUserType from './pages/ChooseUserType'
import SignUpPage1 from './pages/SignUpPage1'
import SignUpPage2 from './pages/SignUpPage2'
import ConfirmOrganization from './pages/ConfirmOrganization'
import UserConfirmationModal from './UserConfirmationModal'
import { api } from 'components/api'
import { userStatusPath } from '../routes/api'
import SignIn from './pages/SignIn'
import SsoSignIn from './pages/SsoSignIn'
import EnterCode from './pages/EnterCode'
import SetPassword from './pages/SetPassword'
import InvalidEmail from './pages/InvalidEmail'
import PendingApproval from './pages/PendingApproval'
import VerifyUser from './pages/VerifyUser'

class SignUpModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = this.initialState()
  }

  initialState = () => ({
    email: '',
    name: '',
    confirmed: false,
    domainOrganizations: []
  })

  handleModalClose = (close) => {
    if (!this.state.confirmed) {
      this.setState(this.initialState())
      close()
    }
  }

  renderPage = ({
    currentPage,
    advanceToPage,
    goBackToPreviousPage,
    close
  }) => {
    const onVerificationSuccess = () => {
      this.setState({ confirmed: true })
      advanceToPage('SetPassword')
    }

    const advanceToVerifyUser = () => {
      api.get({
        url: userStatusPath(),
        params: { email: this.state.email },
        cacheOptions: { enabled: false }
      })
        .then((response) => {
          this.setState({
            organizationName: response.data.user.organization_name,
            stateName: response.data.user.state_name
          })
          advanceToPage('VerifyUser')
        })
    }

    switch (currentPage) {
      case 'ChooseUserType':
        return (
          <ChooseUserType
            onSuccess={() => {
              advanceToPage('SignUpPage1')
            }}
            onSignIn={() => {
              close()
              $(`#${this.props.signInModalId}`).foundation('open')
            }}
          />
        )
      case 'SignUpPage1':
        return (
          <SignUpPage1
            name={this.state.name}
            email={this.state.email}
            emailDisabled={false}
            subHeaderMessage={
              <p className='message'>
                Submit your information to request access.
              </p>
          }
            onGoBack={goBackToPreviousPage}
            onSuccess={(data) => {
              this.setState(data)
              api.get({
                url: userStatusPath(),
                params: { email: data.email },
                cacheOptions: { enabled: false }
              }).then((response) => {
                const user = response?.data?.user || {}
                const status = user.status
                const shouldConfirm = !!user.should_confirm
                const signInBlocked = !!user.sign_in_blocked
                const domainOrganizations = user.domain_organizations || []

                this.setState({
                  alternateSignInUrl: user.alternate_sign_in_url,
                  domainOrganizations
                })

                if (signInBlocked && !['rejected', 'disabled'].includes(status)) {
                  this.setState({ signInBlocked: true })
                  advanceToPage('SsoBlockedSignIn')
                  return
                }

                if (!['rejected', 'disabled'].includes(status) && user.alternate_sign_in_url && !user.has_password) {
                  advanceToPage('SsoSignIn')
                  return
                }

                switch (status) {
                  case 'verified':
                  case 'self_registered':
                  case 'approved':
                  case 'preloaded':
                  case 'phonerep_added':
                    advanceToPage(shouldConfirm ? 'EnterCode' : 'SignIn')
                    break

                  case 'rejected':
                  case 'disabled':
                    advanceToPage('InvalidEmail')
                    break

                  case 'supplier_self_registered':
                    advanceToPage('PendingApproval')
                    break

                  default:
                    advanceToPage(domainOrganizations.length > 0 ? 'ConfirmOrganization' : 'SignUpPage2')
                    break
                }
              })
            }}
          />
        )
      case 'SignUpPage2':
        return (
          <SignUpPage2
            email={this.state.email}
            name={this.state.name}
            subHeaderMessage={
              <>
                <p className='message'>
                  Procurated is a private platform of procurement professionals
                  from governments, education institutions, and non-profits,
                  across the country.
                </p>
                <p className='message'>
                  Submit your information to request access.
                </p>
              </>
          }
            onGoBack={goBackToPreviousPage}
            onSuccess={() => {
              advanceToPage('EnterCode')
            }}
          />
        )
      case 'ConfirmOrganization':
        return (
          <ConfirmOrganization
            name={this.state.name}
            email={this.state.email}
            organizations={this.state.domainOrganizations}
            subHeaderMessage={
              <p className='message'>
                Select the organization you work for to request access.
              </p>
            }
            onGoBack={goBackToPreviousPage}
            onSuccess={() => {
              advanceToPage('EnterCode')
            }}
          />
        )
      case 'SsoSignIn':
        return (
          <SsoSignIn
            ssoSignInUrl={this.state.alternateSignInUrl}
            supportEmail={this.props.supportEmail}
            onSetPassword={() => advanceToPage('EnterCode')}
          />
        )
      case 'SignIn':
        return (
          <SignIn
            email={this.state.email}
            ssoSignInUrl={this.state.alternateSignInUrl}
            onSuccess={() => {
              const redirectTo = localStorage.getItem('redirect_to')
              localStorage.removeItem('redirect_to')
              if (redirectTo) {
                window.location.href = redirectTo
              } else {
                window.location.reload()
              }
            }}
            onResetPassword={() => advanceToPage('EnterCode')}
          />
        )
      case 'EnterCode':
        return (
          <EnterCode
            email={this.state.email}
            supportEmail={this.props.supportEmail}
            readyToSendInitialCode
            onSuccess={onVerificationSuccess}
            onAdvanceToVerifyUser={advanceToVerifyUser}
          />
        )
      case 'VerifyUser':
        return (
          <VerifyUser
            name={this.state.name}
            email={this.state.email}
            organizationName={this.state.organizationName}
            stateName={this.state.stateName}
            onSuccess={onVerificationSuccess}
            onGoBack={goBackToPreviousPage}
          />
        )
      case 'SetPassword':
        return (
          <SetPassword
            email={this.state.email}
            supportEmail={this.props.supportEmail}
            onSuccess={() => { window.location.href = '/' }}
          />
        )
      case 'InvalidEmail':
        return (
          <InvalidEmail
            headerMessage='Access Denied'
            supportEmail={this.props.supportEmail}
            subHeaderMessage={
              <>
                Procurated is a private community of public procurement
                professionals and the suppliers who serve them. Please{' '}
                <a href={`mailto:${this.props.supportEmail}`}>
                  contact support
                </a>{' '}
                if you believe you have received this message in error.
              </>
            }
          />
        )
      case 'SsoBlockedSignIn':
        return (
          <SsoSignIn
            ssoSignInUrl={this.state.alternateSignInUrl}
            supportEmail={this.props.supportEmail}
          />
        )
      case 'PendingApproval':
        return <PendingApproval />
    }
  }

  render () {
    return (
      <UserConfirmationModal
        render={this.renderPage}
        initialPage='ChooseUserType'
        modalId={this.props.modalId}
        onModalClose={this.handleModalClose}
      />
    )
  }
}

SignUpModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  signInModalId: PropTypes.string,
  supportEmail: PropTypes.string.isRequired
}

SignUpModal.defaultProps = {
  signInModalId: null
}

export default SignUpModal
